import { motion } from "framer-motion";
import { useState } from "react";
import { MapPin, Phone, Globe2, Info } from "lucide-react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";
import { Link } from "react-router-dom";
import { Landmark } from "lucide-react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
const agriImg = "/img/Plant-Industry.jpg";
const commerceImg = "/img/Commerce.webp";
const defenseImg = "/img/Defense-Industry-scaled.jpeg";
const energy =
  "/img/4k-time-lapse-silhouette-of-a-network-at-transfor-2024-10-19-21-38-58-utc_1.jpg";
const home =
  "/img/25_0224_opa_making-america-safe-again-s1-rides-with-border-patrol.jpg.webp";
const house = "/img/house.jpg";
const interior = "/img/blm-part-department-interior.jpg";
const justice = "/img/download.jpeg";
const labour = "/img/GettyImages-2159103222.webp";
const transport = "/img/IMT-helping-public.jpg";
const treasure = "/img/8be811169a9a696a569f53ea4b323843a69fdd33-4030x2267.avif";
const veteran = "/img/DBHatch.png";
const enve = "/img/usfws-r8-hero.jpg";
const sys = "/img/sys.png";
const soc = "/img/news5.jpeg";
const sm = "/img/SBA_new.jpg";
const agriImgl = "/img/dagri-removebg-preview.png";
const commerceImgl =
  "/img/Screenshot_from_2025-05-24_11-08-03-removebg-preview.png";
const defenseImgl = "/img/ddefence-removebg-preview.png";
const energyl = "/img/channels4_profile__1_-removebg-preview.png";
const homel = "/img/dhome-removebg-preview.png";
const housel = "/img/dhouse-removebg-preview.png";
const interiorl = "/img/dint-removebg-preview.png";
const justicel = "/img/djust-removebg-preview.png";
const labourl = "/img/dlab-removebg-preview.png";
const transportl = "/img/dtrans-removebg-preview.png";
const treasurel = "/img/dtreas-removebg-preview.png";
const veteranl = "/img/dvetr-removebg-preview.png";
const envel = "/img/denv-removebg-preview.png";
const sysl = "/img/dadm-removebg-preview.png";
const socl = "/img/dsoc-removebg-preview.png";
const sml = "/img/dsmall-removebg-preview.png";
const dhsA = "/img/homeland_security.jpg";
const dhsB = "/img/hsB.jpg";
const dhsC = "/img/DHS_C.webp";
const dhsD = "/img/DHS_D.webp";
const def = "/img/f-16.avif";
const dot = "/img/DOT.jpg";
const immigration = "/img/immigration.jpg";

const departments = [
  {
    name: "Small Business Administration (SBA)",
    backgroundImage: sm,
    logo: sml,
    agencies: [
      {
        id: 161,
        name: "SBA Utah District Office",
        description:
          "Support for small businesses (loans, counseling, training)",
        address: "125 S. State Street, Room 2200, Salt Lake City, UT 84138",
        phone: "(801) 524-3200",
        website: "https://www.sba.gov/offices/district/ut/salt-lake-city",
        url: "/utah-at-a-glance/federal-agencies/sba-advocacy",
      },
      {
        id: 162,
        name: "SBA Advocacy",
        description:
          "Support for small businesses (loans, counseling, training)",
        address: "125 S. State Street, Room 2200, Salt Lake City, UT 84138",
        phone: "(801) 524-3200",
        website: "https://www.sba.gov/offices/district/ut/salt-lake-city",
        // url: "/utah-at-a-glance/federal-agencies/sba-advocacy"
      },
    ],
  },
  {
    name: "Department of Agriculture (USDA)",
    backgroundImage: agriImg,
    logo: agriImgl,
    agencies: [
      {
        id: 11,
        name: "USDA Rural Development (RD) - Utah State Office",
        description: "Rural housing, business, and community development",
        address: "125 S. State Street, Room 4311, Salt Lake City, UT 84138",
        phone: "(801) 524-4320",
        website: "https://rd.usda.gov",
      },
      {
        id: 12,
        name: "Natural Resources Conservation Service (NRCS) - Utah State Office",
        description: "Soil conservation, environmental quality, farming",
        address: "125 South State Street, Room 6416, Salt Lake City, UT 84138",
        phone: "(801) 524-4550",
        website: "https://nrcs.usda.gov",
      },
      {
        id: 13,
        name: "U.S. Forest Service (USFS) - Intermountain Region (R4)",
        description: "National forest management, recreation, conservation",
        address: "324 25th Street, Ogden, UT 84401",
        phone: "(801) 625-5300 (Intermountain Region)",
        website: "https://fs.usda.gov",
      },
      {
        id: 14,
        name: "Farm Service Agency (FSA) - Utah State Office",
        description: "Farm loans, commodity programs, disaster assistance",
        address: "125 S. State Street, Room 4001, Salt Lake City, UT 84138",
        phone: "(801) 524-4200",
        website: "https://fsa.usda.gov",
      },
    ],
  },
  {
    name: "Department of Commerce(DOC)",
    backgroundImage: commerceImg,
    logo: commerceImgl,
    agencies: [
      {
        id: 21,
        name: "Department of Commerce",
        description: "Regulates business and professional licensing",
        // address: '2242 W. North Temple, Salt Lake City, UT 84116',
        address:
          "Heber M. Wells Building, 160 East 300 South, Salt Lake City, Utah 84111",
        phone: "801-530-6701",
        website: "https://commerce.utah.gov/",
      },
    ],
  },
  {
    name: "Department of Defense(DOD)",
    backgroundImage: defenseImg,
    logo: defenseImgl,
    agencies: [
      {
        id: 31,
        name: "Hill Air Force Base",
        description: "Air Force operations, logistics, maintenance",
        address:
          "Hill Air Force Base, UT 84056 (Various Addresses within the Base)",
        phone: "(801) 777-1000 (Base Operator)",
        website: "https://www.hill.af.mil/",
        backgroundImage: def,
      },
      {
        id: 32,
        name: "Defense Commissary Agency (DeCA) - Hill AFB",
        description: "Military commissaries",
        address: "7451 6th Street, Bldg 400, Hill AFB, UT 84056",
        phone: "(801) 777-2277 (Hill AFB Commissary)",
        website: "https://commissaries.com",
      },
    ],
  },
  {
    name: "Department of Energy (DOE)",
    backgroundImage: energy,
    logo: energyl,
    agencies: [
      {
        id: 41,
        name: "Office of Legacy Management (Salt Lake City Disposal & Processing Sites)",
        description: "Long-term stewardship of former atomic energy sites",
        address: "(Administered from Grand Junction, CO office)",
        phone: "(970) 248-6070 (Grand Junction, CO office overseeing)",
        website: "https://energy.gov/lm",
      },
    ],
  },
  {
    name: "Department of Homeland Security (DHS)",
    backgroundImage: home,
    logo: homel,
    agencies: [
      {
        id: 51,
        name: "Customs and Border Protection (CBP) - Port of Salt Lake City",
        description: "Border security, trade facilitation",
        address: "2242 W. North Temple, Salt Lake City, UT 84116",
        phone: "(801) 524-4113",
        website: "https://cbp.gov",
        backgroundImage: dhsB,
      },
      {
        id: 52,
        name: "Immigration and Customs Enforcement (ICE) - Salt Lake City",
        description: "Immigration law enforcement, criminal investigations",
        address: "2975 Decker Lake Dr, Suite 100, West Valley City, UT 84119",
        phone: "(801) 524-4600 (Main Salt Lake City Office)",
        website: "https://ice.gov",
        backgroundImage: immigration,
      },
      {
        id: 53,
        name: "Federal Emergency Management Agency (FEMA) - Region 8",
        description: "Emergency management, disaster response",
        address:
          "West 6th Avenue and Kipling Street, Building 710, Denver, CO 80225",
        phone: "(303) 235-4800 (Denver Regional Office)",
        website: "https://fema.gov",
        backgroundImage: dhsB,
      },
      {
        id: 54,
        name: "Transportation Security Administration (TSA) - Salt Lake City Intl. Airport",
        description: "Airport security",
        address: "Salt Lake City International Airport (SLC)",
        phone: "(866) 289-9673 (General TSA Inquiries)",
        website: "https://tsa.gov",
        backgroundImage: dhsB,
      },
    ],
  },

  {
    name: "Department of Housing and Urban Development (HUD)",
    backgroundImage: house,
    logo: housel,
    agencies: [
      {
        id: 61,
        name: "HUD Salt Lake City Field Office",
        description: "Housing and community development",
        address: "125 S. State Street, Room 3006, Salt Lake City, UT 84138",
        phone: "(801) 524-5222",
        website: "https://hud.gov",
      },
    ],
  },

  {
    name: "Department of Interior (DOI)",
    backgroundImage: interior,
    logo: interiorl,
    agencies: [
      {
        id: 71,
        name: "Bureau of Land Management (BLM) - Utah State Office",
        description: "Public land management, resource development",
        address: "440 West 200 South, Suite 500, Salt Lake City, UT 84101",
        phone: "(801) 539-4001",
        website: "https://blm.gov/utah",
      },
      // {
      //   id: 72,
      //   name: "U.S. Forest Service (USFS)",
      //   description: "National forest management, conservation",
      //   address: "324 25th Street, Ogden, UT 84401",
      //   phone: "(801) 625-5605 (Regional Office)",
      //   website: "https://fs.usda.gov",
      // },
      {
        id: 73,
        name: "U.S. Geological Survey (USGS) - Utah Water Science Center",
        description: "Earth science, water resources, natural hazards",
        address: "2329 West 2300 South, Salt Lake City, UT 84119",
        phone: "(801) 908-5000",
        website: "https://usgs.gov",
      },
      {
        id: 74,
        name: "National Park Service (NPS)",
        description:
          "Management of national parks (Zion, Bryce Canyon, Arches, Canyonlands)",
        address: "12795 W. Alameda Parkway, Lakewood, CO 80228",
        phone: "(801) 777-8822 (Intermountain Regional Office)",
        website: "https://nps.gov",
      },
      {
        id: 75,
        name: "Bureau of Reclamation (USBR) - Upper Colorado Region",
        description: "Water resource management, hydropower",
        address: "125 South State Street, Room 8100, Salt Lake City, UT 84138",
        phone: "(801) 524-3860 (Regional Office)",
        website: "https://usbr.gov",
      },
    ],
  },

  {
    name: "Department of Justice (DOJ)",
    backgroundImage: justice,
    logo: justicel,
    agencies: [
      {
        id: 81,
        name: "U.S. Attorney's Office, District of Utah",
        description: "Federal prosecution, legal affairs",
        address: "111 S. Main St., Suite 1800, Salt Lake City, UT 84111",
        phone: "(801) 524-5600",
        website: "https://justice.gov/usao/ut",
      },
      {
        id: 82,
        name: "Federal Bureau of Investigation (FBI) - Salt Lake City Field Office",
        description: "Federal crime investigation, national security",
        address: "5425 West Amelia Earhart Drive, Salt Lake City, UT 84116",
        phone: "(888) PAGE-FBI or (801) 579-6400",
        website: "https://fbi.gov/contact-us/field-offices/saltlakecity",
      },
      {
        id: 83,
        name: "Drug Enforcement Administration (DEA) - Salt Lake City District Office",
        description: "Drug law enforcement",
        address:
          "(Often co-located with other federal/local law enforcement, specific public address may vary)",
        phone: "(801) 251-5100 (Salt Lake City Office)",
        website: "https://dea.gov",
      },
    ],
  },

  {
    name: "Department of Labor (DOL)",
    backgroundImage: labour,
    logo: labourl,
    agencies: [
      {
        id: 91,
        name: "Occupational Safety and Health Administration (OSHA) - Salt Lake City Area Office",
        description: "Workplace safety and health enforcement",
        address: "160 East 300 South, 3rd Floor, Salt Lake City, UT 84111",
        phone: "(801) 524-5070",
        website: "https://osha.gov",
      },
      {
        id: 92,
        name: "Wage and Hour Division (WHD) - Salt Lake City District Office",
        description: "Enforcement of labor laws",
        address: "125 S. State St., Room 5005, Salt Lake City, UT 84138",
        phone: "1-866-487-9243 (National Toll-Free)",
        website: "https://dol.gov/agencies/whd",
      },
    ],
  },

  {
    name: "Department of Transportation (DOT)",
    backgroundImage: transport,
    logo: transportl,
    agencies: [
      {
        id: 101,
        name: "Federal Highway Administration (FHWA) - Utah Division",
        description: "Federal highway programs, road safety",
        address: "2520 West 4700 South, Suite 9A, Salt Lake City, UT 84129",
        phone: "(801) 955-3500",
        website: "https://highways.dot.gov/field-offices/utah",
      },
      {
        id: 102,
        name: "Federal Aviation Administration (FAA) - Salt Lake City Flight Standards District Office (FSDO)",
        description: "Aviation safety, air traffic control",
        address:
          "6500 W. Amelia Earhart Dr., Suite B, Salt Lake City, UT 84116",
        phone: "(801) 257-5000 (SLC FSDO)",
        website: "https://faa.gov",
        backgroundImage: dot,
      },
    ],
  },

  {
    name: "Department of Treasury (DOT)",
    backgroundImage: treasure,
    logo: treasurel,
    agencies: [
      {
        id: 111,
        name: "Internal Revenue Service (IRS) - Taxpayer Assistance Centers (TACs)",
        description: "Tax collection, taxpayer services",
        address:
          "Multiple locations in Utah, e.g., 210 N. 1950 W., Salt Lake City, UT 84116",
        phone: "1-800-829-1040 (Taxpayer Assistance)",
        website: "https://irs.gov",
      },
    ],
  },

  {
    name: "Department of Veterans Affairs (VA)",
    backgroundImage: veteran,
    logo: veteranl,
    agencies: [
      {
        id: 121,
        name: "VA Salt Lake City Health Care System",
        description: "Healthcare for veterans",
        address: "500 Foothill Drive, Salt Lake City, UT 84148",
        phone: "(801) 582-1565 (Salt Lake City)",
        website: "https://va.gov/salt-lake-city-health-care/",
      },
      {
        id: 122,
        name: "Veterans Benefits Administration (VBA) - Salt Lake City Regional Office",
        description: "Benefits services (disability, education, home loans)",
        address: "550 Foothill Drive, Salt Lake City, UT 84158",
        phone: "1-800-827-1000 (National Benefits Line)",
        website:
          "https://va.gov/find-locations/?address=Salt%20Lake%20City,%20UT",
      },
    ],
  },

  {
    name: "Environmental Protection Agency (EPA)",
    backgroundImage: enve,
    logo: envel,
    agencies: [
      {
        id: 131,
        name: "EPA Region 8 (Denver-based, covers Utah)",
        description: "Environmental protection, regulations",
        address: "1595 Wynkoop Street, Denver, CO 80202-1129",
        phone: "(303) 312-6312 (Denver Regional Office)",
        website: "https://epa.gov/aboutepa/epa-region-8-mountains-and-plains",
      },
    ],
  },
  {
    name: "General Services Administration (GSA)",
    backgroundImage: sys,
    logo: sysl,
    agencies: [
      {
        id: 141,
        name: "GSA Region 8 (Denver-based, covers Utah)",
        description: "Federal property management, procurement",
        address: "1800 Broadway, Denver, CO 80202",
        phone: "(303) 236-8000 (Denver Regional Office)",
        website: "https://gsa.gov/about-us/gsa-regions/region-8-rocky-mountain",
      },
    ],
  },
  {
    name: "Social Security Administration (SSA)",
    backgroundImage: soc,
    logo: socl,
    agencies: [
      {
        id: 151,
        name: "Social Security Administration - Various Field Offices",
        description: "Social Security benefits, Medicare",
        address:
          "Multiple locations in Utah, e.g., 175 E. 400 S., Suite 100, Salt Lake City, UT 84111",
        phone: "1-800-772-1213 (National Toll-Free)",
        website: "https://ssa.gov",
      },
    ],
  },
];

const AgencyCards = () => {
  const [expandedCard, setExpandedCard] = useState(null);
  const [activeTab, setActiveTab] = useState(
    "Small Business Administration (SBA)"
  );

  const toggleCard = (id) => {
    setExpandedCard(expandedCard === id ? null : id);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <LandingSection
        data={{
          imageName: "new-york-city-ellis-island-great-hall.webp",
          title: "Utah Federal Agencies",
          visible: "true",
        }}
      />

      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>Utah Federal Agencies</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Utah is home to various federal departments and agencies that
              support public services, defense, land management, and community
              development across the state.
            </p>
            <Link to={"/about"}>
              {/* <ActionButton data="Know More About Us" /> */}
            </Link>
          </div>
        </div>
      </div>

      <div className="tabtitle">
        <p>Select a Tag - To display data, for that Federal Agency: </p>
      </div>

      <Tabs
        id="finance-tabs-row1"
        activeKey={activeTab}
        onSelect={(tab) => setActiveTab(tab)}
        variant="pills"
        className="mb-3 flex flex-wrap justify-center gap-2 custom-tabs"
      >
        {departments.slice(0, 4).map((item, index) => (
          <Tab key={index} eventKey={item.name} title={item.name} />
        ))}
      </Tabs>

      <Tabs
        id="finance-tabs-row2"
        activeKey={activeTab}
        onSelect={(tab) => setActiveTab(tab)}
        variant="pills"
        className="mb-3 flex flex-wrap justify-center gap-2 custom-tabs"
      >
        {departments.slice(4, 8).map((item, index) => (
          <Tab key={index + 5} eventKey={item.name} title={item.name} />
        ))}
      </Tabs>

      <Tabs
        id="finance-tabs-row2"
        activeKey={activeTab}
        onSelect={(tab) => setActiveTab(tab)}
        variant="pills"
        className="mb-3 flex flex-wrap justify-center gap-2 custom-tabs"
      >
        {departments.slice(8, 12).map((item, index) => (
          <Tab key={index + 5} eventKey={item.name} title={item.name} />
        ))}
      </Tabs>
      <Tabs
        id="finance-tabs-row2"
        activeKey={activeTab}
        onSelect={(tab) => setActiveTab(tab)}
        variant="pills"
        className="mb-3 flex flex-wrap justify-center gap-2 custom-tabs"
      >
        {departments.slice(12, 16).map((item, index) => (
          <Tab key={index + 5} eventKey={item.name} title={item.name} />
        ))}
      </Tabs>

      {departments.find((d) => d.name === activeTab) ? (
        <div className="flex-grow max-w-7xl mx-auto py-12 w-full">
          {departments
            .filter((d) => d.name === activeTab)
            .map((department, deptIndex) => (
              <div key={deptIndex} className="mb-12">
                <h2 className="text-3xl sm:text-4xl font-bold mb-8 text-center text-blue-900">
                  {department.name}
                </h2>

                <div className="flex justify-center gap-6 px-4 sm:px-6 lg:px-8">
                  {department.agencies.map((agency, index) => (
                    <motion.div
                      key={agency.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: index * 0.1, duration: 0.3 }}
                      className="w-full sm:w-80 lg:w-80"
                    >
                      <div
                        className={`bg-white rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden transition-all duration-300 ${expandedCard === agency.id ? "ring-2 ring-blue-500" : ""}`}
                      >
                        <div
                          className="relative h-60 cursor-pointer group"
                          onClick={() => {
                            if (agency.id === 162) {
                              window.location.href =
                                "/utah-at-a-glance/federal-agencies/sba-advocacy";
                            } else {
                              toggleCard(agency.id);
                            }
                          }}
                          style={{
                            backgroundImage: `url(${agency.backgroundImage || department.backgroundImage})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        >
                          <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors duration-300" />

                          <div className="absolute inset-0 flex items-center justify-center p-4">
                            <h3 className="text-xl font-semibold text-center text-white drop-shadow-md">
                              {agency.name}
                            </h3>
                          </div>
                        </div>

                        <motion.div
                          className="overflow-hidden"
                          initial={{ height: 0 }}
                          animate={{
                            height: expandedCard === agency.id ? "auto" : 0,
                          }}
                          transition={{ duration: 0.3 }}
                        >
                          <div className="p-6 space-y-4 text-gray-700 bg-gray-50">
                            <div className="flex items-center gap-3">
                              <MapPin
                                className="flex-shrink-0 text-blue-600"
                                size={18}
                              />
                              <span>{agency.address}</span>
                            </div>

                            <div className="flex items-center gap-3">
                              <Phone
                                className="text-blue-600 flex-shrink-0"
                                size={18}
                              />
                              <span className="text-gray-800">
                                {agency.phone}
                              </span>
                            </div>

                            <div className="flex items-center gap-3">
                              <Globe2 className="text-blue-600" size={18} />
                              <a
                                href={agency.website}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:underline"
                              >
                                Visit Website
                              </a>
                            </div>

                            <div className="flex items-center gap-3">
                              <Info
                                className="flex-shrink-0 text-blue-600"
                                size={18}
                              />
                              <span className="text-sm">
                                {agency.description}
                              </span>
                            </div>
                          </div>
                        </motion.div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </div>
            ))}
        </div>
      ) : (
        ""
      )}

      <Footer />
    </div>
  );
};

export default AgencyCards;
